const days = [
  { id: 'Monday', text: 'Понедельник' },
  { id: 'Tuesday', text: 'Вторник' },
  { id: 'Wednesday', text: 'Среда' },
  { id: 'Thursday', text: 'Четверг' },
  { id: 'Friday', text: 'Пятница' },
  { id: 'Saturday', text: 'Суббота' },
  { id: 'Sunday', text: 'Воскресение' },
]

export { days }